import React from 'react';
import LegalLayout from './LegalLayout';

const Terms = () => (
  <LegalLayout eyebrow="Legal" title="Terms of Use" updated="1 January 2026">
    <p>By using the Elevate Medical Clinics website (“the Site”) you agree to these terms. If you do not agree, please do not use the Site.</p>

    <h2>Not medical advice</h2>
    <p>The information on this Site is provided for general educational purposes only. It is not a substitute for personalised medical advice, diagnosis or treatment. Always consult a qualified healthcare professional about your individual circumstances. In an emergency, call 000.</p>

    <h2>Bookings and enquiries</h2>
    <p>Bookings submitted through this Site (or through third-party booking platforms we link to) are enquiries only until confirmed by our reception team. Fees, availability and clinical suitability are determined at the time of booking.</p>

    <h2>Intellectual property</h2>
    <p>All content on this Site (including text, graphics, logos, images and code) is owned by or licensed to Elevate Medical Clinics and is protected by Australian and international copyright laws. You may not reproduce, distribute or exploit any content without our written permission.</p>

    <h2>Third-party links</h2>
    <p>The Site may link to third-party websites (for example, our booking platform). We are not responsible for the content or privacy practices of any third-party site.</p>

    <h2>Limitation of liability</h2>
    <p>To the extent permitted by law, Elevate Medical Clinics is not liable for any loss or damage arising from your use of the Site, other than in connection with clinical care rendered under our professional obligations.</p>

    <h2>Governing law</h2>
    <p>These terms are governed by the laws of Western Australia.</p>
  </LegalLayout>
);

export default Terms;
